import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  dh_wb: {
    '/:brand/lto': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'dh/lto',
        height: '100vh',
      },
    },
  },
}

export default demo
